import { render, staticRenderFns } from "./NotificationArea.vue?vue&type=template&id=7b5fc05e&scoped=true&"
import script from "./NotificationArea.vue?vue&type=script&lang=js&"
export * from "./NotificationArea.vue?vue&type=script&lang=js&"
import style0 from "./NotificationArea.vue?vue&type=style&index=0&id=7b5fc05e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5fc05e",
  null
  
)

export default component.exports